// Formatting helpers for Summit Ridge Bank
export const esc = (s) => String(s);

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  if (typeof d === "string") return d;
  if (d) return JSON.stringify(d);
  return "Something went wrong. Please try again.";
}
export const usd = (c) =>
  (c < 0 ? "-" : "") +
  "$" +
  Math.abs(c / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const usd0 = (c) =>
  (c < 0 ? "-" : "") + "$" + Math.abs(Math.round(c / 100)).toLocaleString("en-US");

export const iso = (d) => {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return z.toISOString().slice(0, 10);
};
export const today = () => iso(new Date());
export const dShort = (s) =>
  new Date(s + "T12:00:00").toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
export const dLong = (s) =>
  new Date(s + "T12:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
export const mName = (m) => {
  const p = m.split("-");
  return new Date(+p[0], +p[1] - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
};

export function csvOf(rows) {
  return (
    "SAMPLE DATA - NOT A FINANCIAL DOCUMENT\n" +
    "Date,Description,Category,Method,Reference,Amount,Balance\n" +
    rows
      .map((r) =>
        [
          r.date,
          '"' + String(r.desc).replace(/"/g, '""') + '"',
          r.cat,
          r.method,
          r.ref,
          (r.amount / 100).toFixed(2),
          r.balanceAfter != null ? (r.balanceAfter / 100).toFixed(2) : "",
        ].join(",")
      )
      .join("\n")
  );
}

export function download(text, name, type) {
  const b = new Blob([text], { type: type || "text/csv;charset=utf-8" });
  const u = URL.createObjectURL(b);
  const a = document.createElement("a");
  a.href = u;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(u);
    a.remove();
  }, 1500);
}
